import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Container, Button, Typography, CircularProgress } from "@material-ui/core";
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@apollo/client';
import { ModerateFileWindow } from './ModerateFileWindow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import * as lodash from 'lodash';

export const ModerateFiles = () => {
    const useStyles = makeStyles(theme => ({
        root: {
            padding: theme.spacing(1, 2),
        },
        fileRow: {
            '&:hover': {
                backgroundColor: `#E8E8E8`,
                border: `1px solid ${theme.palette.primary.main}`,
            }
        },
        addFileButton: {
            right: '48px',
            position: 'absolute'
        },
        cards: {
            paddingRight: '50px'
        },

        usersCell: {
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
            lineHeight: 1.4,
            maxWidth: 360,
        }

    }));

    const classes = useStyles();

    const GET_FILES = gql`
        query GetFiles($approved: Boolean,$newProcess: Boolean) {
            file(approved: $approved,newProcess: $newProcess) {
                id
                companyId
                fileName
                originalFileNames
                dateUploaded
                expirationDate
                encryptedPassword
                justification
                selectedUsers
                newProcess
                managerApproved
                company {
                  name
                }
                user {
                  email
                }
            }
        }
    `;

    const APPROVE_FILE = gql`
        mutation ApproveFile($fileId: Int!, $approved: Boolean!) {
            approveFile(fileId: $fileId, approved: $approved) {
                approved
            }
        }
    `;
    //zip and email function
    const ZIP_AND_EMAIL = gql`
    mutation ZipAndEmail($userName: String!,$fileName: String!, $password: String!, $recipientIds: String!) {
        zipAndEmail(userName:$userName,fileName: $fileName, password: $password, recipientIds: $recipientIds) 
    }
`;
    const [zipAndEmailMutation] = useMutation(ZIP_AND_EMAIL);
    const [encryptedPassword, setEncryptedPassword] = useState('');

    const [approveFileMutation] = useMutation(APPROVE_FILE);

    const { loading, error, data, refetch } = useQuery(GET_FILES, { variables: { approved: false, newProcess: true } });
    const [checkedFiles, setCheckedFiles] = useState(false);
    const [loadingFiles, setLoadingFiles] = useState(false);
    const [files, setFiles] = useState('');

    const [showModerateFileWindow, setShowModerateFileWindow] = useState(false);

    const [selectedFileId, setSelectedFileId] = useState();


    useEffect(() => {
        if (data) {
            setFiles(data.file);
        }

    }, [data]);

    const onFileRowClick = (fileId) => {
        setSelectedFileId(fileId, setShowModerateFileWindow(true));
    }

    const onCloseModerateFileWindow = () => {
        setShowModerateFileWindow(false);
        setFiles([]);
        refetch();
    }

    const onApproveClick = (fileId, approved) => {
        var filesCopy = lodash.cloneDeep(files);
        var fileObj = filesCopy.find(x => x.id === fileId);
        console.log(fileObj);
        filesCopy.find(x => x.id === fileId).loading = true;
        approveFileMutation({ variables: { fileId: fileId, approved: approved } }).then(r => {

            filesCopy.find(x => x.id === fileId).processed = true;
            filesCopy.find(x => x.id === fileId).approved = approved;
            filesCopy.find(x => x.id === fileId).loading = false;

            if (approved) {
                // Requirement: Show stored encrypted password
                const encPwd = filesCopy.find(x => x.id === fileId).encryptedPassword;

                setEncryptedPassword(encPwd);
            }
            setFiles(filesCopy);
        })
            .catch(x => {
                filesCopy.find(x => x.id === fileId).loading = false;
                filesCopy.find(x => x.id === fileId).error = false;
            });
    }
    const handleZipAndEmail = async (fileId) => {
        const targetFile = files.find(x => x.id === fileId);
        try {
            await zipAndEmailMutation({
                variables: {
                    userName: targetFile.user.email,
                    fileName: targetFile.fileName,
                    password: targetFile.encryptedPassword,
                    recipientIds: targetFile.selectedUsers,
                }
            });
            // Requirement: Close out request (remove from local list)
            setFiles(prev => prev.filter(f => f.id !== fileId));
        } catch (err) {
            console.error("Email failed", err);
        }
    };
    const breakAtAt = (s = '') => s.replace('@', '\n@');
    return (
        <Container maxWidth={false} disableGutters={true}>
            <Typography variant="h5">Moderate Files</Typography>
            {loading ?
                <CircularProgress />
                :
                files.length > 0 ?
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>File Name</TableCell>
                                    <TableCell>Original File Names</TableCell>
                                    <TableCell>Date Added</TableCell>
                                    <TableCell>Added By</TableCell>
                                    <TableCell>For Company</TableCell>
                                    <TableCell>Justification</TableCell>
                                    <TableCell>Selected Users</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {files.map((item, index) => {
                                    return (
                                        <TableRow key={item.id} className={classes.fileRow}>
                                            <TableCell>{item.fileName}</TableCell>
                                            <TableCell>
                                                {String(item.originalFileNames || '')
                                                    .split(';')
                                                    .map((u, idx) => {
                                                        const t = u.trim();
                                                        if (!t) return null;
                                                        return <div key={idx}>{t}</div>;
                                                    })}
                                            </TableCell>
                                            <TableCell>{item.dateUploaded}</TableCell>
                                            <TableCell>{breakAtAt(item.user.email)}</TableCell>
                                            <TableCell>{item.company.name}</TableCell>
                                            <TableCell className={classes.usersCell}>{item.justification}</TableCell>

                                            <TableCell>
                                                {String(item.selectedUsers || '')
                                                    .split(';')
                                                    .map((u, idx) => {
                                                        const t = u.trim();
                                                        if (!t) return null;
                                                        return <div key={idx}>{t}</div>;
                                                    })}
                                            </TableCell>

                                            <TableCell>
                                                <OpenInNewIcon onClick={() => onFileRowClick(item.id)} style={{ cursor: 'pointer' }} />
                                            </TableCell>
                                            <TableCell>
                                                {item.loading ?
                                                    <CircularProgress />
                                                    :
                                                    item.processed ?
                                                        item.approved ?
                                                            <div>
                                                                <Typography variant="subtitle1">APPROVED</Typography>

                                                                {item.newProcess && (
                                                                    <>

                                                                        <Typography variant="body2"> Enc Pwd: <strong>{item.encryptedPassword}</strong></Typography>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="secondary"
                                                                            size="small"
                                                                            onClick={() => handleZipAndEmail(item.id)}
                                                                        >
                                                                            Zip and Email
                                                                        </Button>

                                                                    </>
                                                                )}

                                                            </div>
                                                            :
                                                            <Typography variant="subtitle1">REJECTED</Typography>
                                                        :
                                                        <React.Fragment>
                                                            <Button variant="contained" color="primary" style={{ marginRight: '10px' }} onClick={() => onApproveClick(item.id, true)}>Approve</Button>
                                                            <Button variant="outlined" color="primary" onClick={() => onApproveClick(item.id, false)}>Reject</Button>
                                                        </React.Fragment>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    :
                    <Typography variant="subtitle1">No Files Available</Typography>
            }
            {selectedFileId &&
                <ModerateFileWindow isOpen={showModerateFileWindow} setIsOpen={onCloseModerateFileWindow} fileId={selectedFileId} />
            }
        </Container>
    )
}